<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:28%">
          	  <el-date-picker v-model="query.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:13%">
              <el-select v-model="query.type" clearable remote  filterable placeholder="请选择奖品类型" style="width:100%" @change="ischange=true">
                  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>   
          </el-form-item>
          <el-form-item style="width:13%">
              <el-select v-model="query.searchtype" remote filterable @change="ischange=true" style="width:100%">
                  <el-option v-for="(item,index) in searchtype" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>   
          </el-form-item>
          <el-form-item style="width:14%">
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getawardlists" @change="ischange=true" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getawardlists" style="with:100%">查询</el-button>
          </el-form-item>   
      </el-form>
     
      <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listsloading">
              <el-table-column type="expand">
		          <template slot-scope="props">
		                <div style="width:99%;color:#606266;padding:15px 0 15px 1%">
		                	<span v-if="props.row.truename!=''">中奖账号：{{props.row.truename}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
		                	<span v-if="props.row.shopname!=''">所属店铺：{{props.row.shopname}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
		                	<span v-if="props.row.phone!=''">手机号码：{{props.row.phone}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span v-if="props.row.documents!=''" style="float:left;width:100%">出库单号：{{props.row.documents}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span v-if="props.row.note!=''" style="float:left;width:100%">备注：{{props.row.note}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
		                </div>
                        <el-table :data="props.row.data">
			                <el-table-column label="奖品图片">
                                <template slot-scope="cprops">
                                    <div><img :src="cprops.row.thumb" style="width:50%"/></div>
                                </template>
                            </el-table-column>
			                <el-table-column prop="name" label="名称/红包金额范围" align="left"></el-table-column>
                            <el-table-column prop="nums" label="数量/金额" align="center"></el-table-column>
		                </el-table>
		          </template>
	          </el-table-column>

	          <el-table-column prop="inputtime" label="中奖时间" width="170"></el-table-column>
              <el-table-column prop="typename" label="奖品类型" width="110"></el-table-column>
              <el-table-column prop="name" label="奖品名称"></el-table-column>
              <el-table-column prop="lottery_sn" label="编号" width="140"></el-table-column>
              <el-table-column prop="status" label="状态" width="110" align="center">
                  <template slot-scope="props">
                      <el-tag type="success" v-if="props.row.status=='自动发放'">{{props.row.status}}</el-tag>
                      <el-tag type="warning" v-if="props.row.status=='手动发放'">{{props.row.status}}</el-tag>
                  </template>
              </el-table-column>
              <el-table-column prop="issend" label="是否发货" width="110" align="center">
                  <template slot-scope="props">
                      <el-tag type="success" v-if="props.row.issend=='已发货'">{{props.row.issend}}</el-tag>
                      <el-tag type="danger" v-if="props.row.issend=='未发货'">{{props.row.issend}}</el-tag>
                  </template>
              </el-table-column>
              
	          <el-table-column label="操作" width="250" align="center">
		            <template slot-scope="scope">
		                <el-button type="warning" size="small" icon="el-icon-edit" v-if="scope.row.issend=='未发货' || scope.row.issend=='已发货'" @click="setshipping(scope.row)">备注</el-button>
		                <el-button type="success" size="small" icon="el-icon-check" v-if="scope.row.issend=='未发货'" @click="gosend(scope.row)">去发货</el-button>
		            </template>
	          </el-table-column>
          </el-table>

          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="drawspageChange"
	            @current-change="drawspageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </div>
          
      <el-dialog title="填写备注" :visible.sync="noteDialog" width="30%" top="10vh">
          <el-input type="textarea" :rows="4" v-model="savenotequery.note"></el-input>
          <div slot="footer" class="dialog-footer">
			  <el-button size="medium" @click="noteDialog = false">取 消</el-button>			        
			  <el-button size="medium" type="primary" @click="createnoteSave">保存</el-button>
		  </div>
      </el-dialog>
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Draws/index",
      transitionshow:true,
      query: {
          act:'awardlists',
          token:this.$cookies.get('token'),
          date:[],
          type:'',
          searchtype:1,
          key:'',
          p:1,
          rollpage:10
      },
      ischange:false,
      lists:[],
      rows:0,
      listsloading:false,
      searchtype:[
          {id:1,name:'奖品名称'},
          {id:2,name:'所属店铺'},
          {id:3,name:'收件人'},
          {id:4,name:'手机号'}
      ],
      typelists:[
          {id:1,name:'谢谢惠顾'},
          {id:2,name:'再来一次'},
          {id:3,name:'优惠券'},
          {id:4,name:'实体奖品'},
          {id:5,name:'现金红包'}
      ],
      savenotequery: {
          act:'savenote',
          token:this.$cookies.get('token'),
          id:'',
          note:''
      },
      noteDialog:false,

    }  
  },
  mounted(){
     this.getawardlists();
  },
  methods:{

      /** 获取活动信息 **/
      getawardlists() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.listsloading=true;
          var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	              this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsloading=false;
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      drawspageChange(val) {
        this.query.rollpage = val;
        this.getawardlists();
      },
      drawspageCurrentChange(val) {
        this.query.p = val;
        this.getawardlists();
      },
      
      /** 去发货 **/
      gosend(item) {
          this.$confirm('您是否已确认过该奖品并对其进行发货, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	  // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'sendgoods',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	    if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('发货成功，请前往销售出库对商品进行出库操作');
                      this.getawardlists();
                  }
              }).catch((res) => {
            	    this.$message.error(this.GLOBAL.errortext);
              });
          }).catch(() => {
        	
          });
      },

      //编辑备注信息
      setshipping(item) {
          this.savenotequery.id=item.id;
          this.savenotequery.note=item.note;

          var resource = this.$resource(this.url);
              resource.save({ act:'getnote',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.note=result.note;
                  this.noteDialog=true;
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },

      //保存备注信息
      createnoteSave() {
          var resource = this.$resource(this.url);
              resource.save(this.savenotequery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.$message.success(res.data.Message);
                  this.noteDialog=false;
                  this.getawardlists();
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },

      

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/award.vue